import { Input } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'
import { setSupplierFilter } from '../../../../../stores/actions'

const StyledRow = styled.div`
  margin-bottom: 10px;
`

export const SearchSupplierDrawerComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { language } = useSelector((state: RootState) => state.language)
  const { supplierFilter } = useSelector((state: RootState) => state.supplier)
  const [filter, setFilter] = React.useState(supplierFilter)

  const body = (
    <>
      <StyledRow>
        <Input
          placeholder={translate('supplier.name', language)}
          addonBefore={translate('supplier.name', language)}
          value={filter.name}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              name: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('supplier.address', language)}
          addonBefore={translate('supplier.address', language)}
          value={filter.address}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              address: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('supplier.phone', language)}
          addonBefore={translate('supplier.phone', language)}
          value={filter.phone}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              phone: e.target.value,
            })
          }
        />
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() => dispatch(setSupplierFilter(filter))}
    />
  )
}
